import { useState } from 'react';

function QRLiveness({ qrCodeUrl, qrLinkUrl }: { qrCodeUrl: string; qrLinkUrl: string }) {
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const [isSuccess, setIsSuccess] = useState(true);

    const handleCopyLink = () => {
        navigator.clipboard.writeText(qrLinkUrl).then(() => {
            setModalMessage('Link copied to clipboard!');
            setIsSuccess(true);
            setShowModal(true);
            setTimeout(() => setShowModal(false), 2500);
        }).catch((err) => {
            console.error('Failed to copy:', err);
            setModalMessage('Failed to copy link');
            setIsSuccess(false);
            setShowModal(true);
            setTimeout(() => setShowModal(false), 3000);
        });
    };

    return (
        <>
            {showModal && (
                <div style={{
                    position: 'fixed',
                    top: '24px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    backgroundColor: isSuccess ? '#10B981' : '#EF4444',
                    color: 'white',
                    padding: '16px 32px',
                    borderRadius: '12px',
                    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.3)',
                    zIndex: 99999,
                    fontSize: '16px',
                    fontWeight: '600',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    animation: 'slideDown 0.3s ease-out',
                    minWidth: '280px',
                    justifyContent: 'center'
                }}>
                    <span style={{ fontSize: '24px' }}>{isSuccess ? '✓' : '✗'}</span>
                    <span>{modalMessage}</span>
                </div>
            )}
            <div style={{
                width: '100%',
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#f0f0f0',
                padding: '20px',
                position: 'relative',
                zIndex: 9999,
                boxSizing: 'border-box'
            }}>
                <div style={{
                    backgroundColor: 'white',
                    padding: '40px',
                    borderRadius: '10px',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    textAlign: 'center',
                    width: '90%',
                    maxWidth: '700px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}>
                    <h2 style={{ marginBottom: '20px', color: '#000000', fontSize: '28px', fontWeight: 'bold' }}>Scan QR Code on Your Phone</h2>
                    <img src={qrCodeUrl} alt="QR Code" style={{ 
                        display: 'block', 
                        margin: '0 auto', 
                        width: '100%',
                        maxWidth: '500px',
                        height: 'auto',
                        aspectRatio: '1/1'
                    }} />
                    <p style={{ marginTop: '24px', color: '#666666', fontSize: '18px', maxWidth: '500px' }}>
                        Scan this QR code with your phone to continue with liveness verification
                    </p>
                    <button
                        onClick={handleCopyLink}
                        style={{
                            marginTop: '28px',
                            padding: '16px 40px',
                            backgroundColor: '#4F46E5',
                            color: 'white',
                            border: 'none',
                            borderRadius: '8px',
                            fontSize: '18px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            boxShadow: '0 2px 4px rgba(79, 70, 229, 0.3)',
                            transition: 'all 0.2s ease',
                            width: '100%',
                            maxWidth: '500px'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#4338CA';
                            e.currentTarget.style.transform = 'translateY(-1px)';
                            e.currentTarget.style.boxShadow = '0 4px 8px rgba(79, 70, 229, 0.4)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = '#4F46E5';
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 2px 4px rgba(79, 70, 229, 0.3)';
                        }}
                    >
                        📋 Copy Link to Clipboard
                    </button>
                </div>
            </div>
            <style>
                {`
                    @keyframes slideDown {
                        from {
                            opacity: 0;
                            transform: translateX(-50%) translateY(-20px);
                        }
                        to {
                            opacity: 1;
                            transform: translateX(-50%) translateY(0);
                        }
                    }
                `}
            </style>
        </>
    );
}

export default QRLiveness;